import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/my-classes')({
  component: lazyRouteComponent(() => import('./-my-classes')),
})
